import { Modal, Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import type { useDisclosure } from "apps/commons/hooks/useDisclosure";
import type { FunctionComponent } from "react";
import { useStaticDataAtomValue } from "../staticDataAtom";

export const LocalLawModal: FunctionComponent<ReturnType<typeof useDisclosure>> = ({ open, onClose }) => {
    const {
        cmsData: {
            publish: {
                localLawModal,
                close,
                itIsYourResponsibility,
                beAwareOfYourLocalRegulations,
                manyCountries,
                workWithinYourOwnCountryLegal,
            },
        },
    } = useStaticDataAtomValue();

    return (
        <Modal
            size="m"
            title={localLawModal}
            visible={open}
            onClose={onClose}
            actions={[
                {
                    label: close,
                    variant: "label",
                    hierarchy: "primary",
                    onClick: onClose,
                    actionType: "button",
                },
            ]}
        >
            <VStack gap="16">
                <Typography variant="body-default-strong">{itIsYourResponsibility}</Typography>
                <Typography variant="body-s">{beAwareOfYourLocalRegulations}</Typography>
                <Typography variant="body-s">{manyCountries}</Typography>
                <Typography variant="body-s">{workWithinYourOwnCountryLegal}</Typography>
            </VStack>
        </Modal>
    );
};
